import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import ProgressivePhoto from '../../ProgressivePhoto';

const propTypes = {
  linkTo: PropTypes.string.isRequired,
  photo: PropTypes.shape({
    id: PropTypes.string,
    thumbnail_urls: PropTypes.array,
  }),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

const PhotoGridCard = ({ linkTo, photo, children }) => {
  return (
    <div className="photo-grid-card">
      <Link to={linkTo}>
        <ProgressivePhoto thumbnails={photo.thumbnail_urls} />
      </Link>
      {children}
    </div>
  );
};

PhotoGridCard.propTypes = propTypes;

export default PhotoGridCard;
